export default __webpack_public_path__ + "static/media/rewriter-on-enterprise-nudge.e7fbcc12.png";